import { render } from "./PerPageSelection.vue?vue&type=template&id=6e2473e6&ts=true"
import script from "./PerPageSelection.vue?vue&type=script&lang=ts"
export * from "./PerPageSelection.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__